import React, { Fragment, useState } from 'react';
import { useNotify } from 'react-admin';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import ButtonUI from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { apiPost } from '../../brainApi';
import { trackFullStoryEvent } from '../../helper';
import SendIcon from '@material-ui/icons/Send';

const SendRescheduleEmail = ({ selectedIds }) => {
  const notify = useNotify();
  const defaultReason =
    'Due to ___, we will need to reschedule your appointment for ';
  const [open, setOpen] = useState(false);
  const [rescheduleFields, setRescheduleFields] = useState({
    swIds: [],
    reason: defaultReason,
    date: '',
    spots: '',
  });

  const handleOpen = () => {
    trackFullStoryEvent('CTA_Send_Reschedule_Email_Click', {
      selected_count: selectedIds?.length || 0,
    });
    setOpen(true);
    setRescheduleFields({
      ...rescheduleFields,
      swIds: [...selectedIds],
    });
  };

  const handleInputChange = (event) => {
    setRescheduleFields({
      ...rescheduleFields,
      [event.currentTarget.id]: event.currentTarget.value,
    });
  };

  const inputIsInvalid = () => {
    return (
      rescheduleFields.reason.includes('___') ||
      !rescheduleFields.date ||
      !rescheduleFields.spots ||
      rescheduleFields.spots < 1 ||
      rescheduleFields.spots.length > 3
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    trackFullStoryEvent('CTA_Send_Reschedule_Email_Submit', {
      sw_count: rescheduleFields.swIds?.length || 0,
      proposed_date: rescheduleFields.date,
      spots: rescheduleFields.spots,
    });
    return apiPost(`/send-reschedule-email`, rescheduleFields).then((json) => {
      if (json.Status === 'Failure') {
        notify(`Error: ${json.Message}`, 'warning');
      } else {
        setOpen(false);
        setRescheduleFields({
          swIds: [],
          reason: defaultReason,
          date: '',
          spots: '',
        });
      }
    });
  };

  return (
    <Fragment>
      <Button onClick={handleOpen} className="send_email">
        Send Reschedule Email
        <SendIcon fontSize="small" />
      </Button>
      <Dialog open={open}>
        <DialogTitle>Send email to reschedule appointment</DialogTitle>
        <DialogContent>
          <TextField
            id="reason"
            helperText="Update text with the reschedule reason. Sentence will be finished with the current appointment date."
            type="text"
            value={rescheduleFields.reason}
            onChange={handleInputChange}
            margin="normal"
            multiline
            fullWidth
          />
          <TextField
            id="date"
            helperText="New Date to propose to customers"
            type="date"
            value={rescheduleFields.date}
            onChange={handleInputChange}
            margin="normal"
            fullWidth
          />
          <TextField
            id="spots"
            helperText="Number of spots available"
            type="number"
            value={rescheduleFields.spots}
            onChange={handleInputChange}
            margin="normal"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <ButtonUI onClick={() => setOpen(false)} color="primary">
            Close
          </ButtonUI>
          <ButtonUI
            color="primary"
            variant="contained"
            onClick={(e) => handleSubmit(e)}
            disabled={inputIsInvalid()}
          >
            <CheckIcon style={{ marginRight: '7px' }} />
            Submit
          </ButtonUI>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default SendRescheduleEmail;
